<template>
    <div class='container'>
        <!-- {{ order[0] }} -->
        <div v-if="judgment == 'true'">
            <div v-for="item in order">
                <div class="order item_area">
                    <div class="ordertitle">
                        <i class="icon-smile-o" style="background-color: #6E7C7C;"></i>
                        <span>您的訂單已成立<br>感謝您的訂購，歡迎再度光臨。</span>
                    </div>
                    <div class="unpaid"
                        v-if="selectpayment.mode !== 'ReceivedPay' && item.payment.status !== 'success' && selectpayment.mode !== 'ReceivedPay711' && selectpayment.st !== 'success'">
                        <div v-if="selectpayment.data_list == -1"
                            style="text-align: center; color: red; font-size: 30px;">
                            付款失敗請聯絡客服
                        </div>
                        <div v-else-if="selectpayment.st === 'checking'">
                            <div id="atm">
                                <div class="status">
                                    <div class="to_pay">
                                        <div class="spinner-border text-primary spinner-border-sm"
                                            style="margin-right: 10px; color: #886b3e !important;" role="status"></div>
                                        等待繳款中...
                                    </div>

                                </div>
                                <div class="button">
                                    <div class="to_pay">
                                        <div class="code">銀行代號：<span style="font-weight: bold;">{{ selectpayment.bk_code
                                                }}</span></div>
                                        <div class="acc">銀行帳號: <span style="font-weight: bold;">{{ selectpayment.bk_acc
                                                }}</span></div>
                                    </div>
                                </div>
                                <div class="tips">
                                    <span>
                                        <svg t="1701399218064" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                            xmlns="http://www.w3.org/2000/svg" p-id="24282">
                                            <path
                                                d="M969.182003 701.303054C942.98583 761.818425 907.560805 814.394635 862.909139 859.030351 818.273423 903.682017 765.86402 939.121773 705.727336 965.303215 645.576031 991.515341 581.182839 1004.606061 512.545547 1004.606061 443.925315 1004.606061 379.349482 991.515341 318.818158 965.303215 258.302785 939.121773 205.726577 903.682017 161.090861 859.030351 116.439196 814.393527 80.999438 761.818425 54.817996 701.303054 28.605873 640.772838 15.515152 576.197117 15.515152 507.575665 15.515152 438.938373 28.605873 374.545181 54.817996 314.393878 80.999438 254.257304 116.439196 201.8479 161.090861 157.212073 205.726577 112.560409 258.302785 77.135381 318.818158 50.939208 379.349482 24.743034 443.925203 11.636364 512.545547 11.636364 581.182839 11.636364 645.576031 24.742924 705.727336 50.939208 765.8628 77.1366 818.273311 112.560409 862.909139 157.212073 907.560805 201.848897 942.984611 254.258412 969.182003 314.393878 995.378179 374.545181 1008.484848 438.938373 1008.484848 507.575665 1008.484848 576.197117 995.379287 640.772838 969.182003 701.303054L969.182003 701.303054Z"
                                                fill="#FF2E00" p-id="24283"></path>
                                            <path
                                                d="M512 709.220647C472.332325 709.220647 440.203301 741.349668 440.203301 781.017346 440.203301 820.68502 472.332325 852.814044 512 852.814044 551.667675 852.814044 583.796699 820.68502 583.796699 781.017346 583.796699 741.349668 551.667675 709.220647 512 709.220647L512 709.220647Z"
                                                fill="#FFFFFF" p-id="24284"></path>
                                            <path
                                                d="M512 639.709091C492.184111 639.709091 476.101651 606.196596 476.101651 564.820837L440.203301 227.823683C440.203301 186.447921 472.332325 152.935427 512 152.935427 551.667675 152.935427 583.796699 186.447921 583.796699 227.823683L547.898349 564.820837C547.898349 606.196596 531.815889 639.709091 512 639.709091L512 639.709091Z"
                                                fill="#FFFFFF" p-id="24285"></path>
                                        </svg> </span> 未付款七日後以貨到付款寄出
                                </div>
                            </div>
                            <!-- 銀行代號:{{ selectpayment.bk_code }}
                            銀行帳號:{{ selectpayment.bk_acc }} -->
                        </div>
                        <form v-else :action="selectpayment.furl" :method="selectpayment.fmethod"
                            style="text-align: center;">
                            <!-- background-color: #558ac5; -->
                            <button type="subimt" class="btn"
                                style="margin-top: 0; background-color: #6E7C7C; color: #ffffff; width: 50%;">前往付款</button>
                            <template v-for="(value, key) in selectpayment.data_list" :key="key">
                                <!-- <input v-if="key === 'ClientBackURL'" type="hidden" :name="key"
                                    :value="value + '?redirect_f2e_href=' + now_url">
                                <input v-else type="hidden" :name="key" :value="value"> -->
                                <input type="hidden" :name="key" :value="value">
                            </template>

                            <!-- <input v-if="key == 'ClientBackUrl'" type="hidden"
                                                    v-for="(value, key) in selectpayment.data_list" :key="key" :name="key"
                                                    :value="value">
                                                <input v-else type="hidden" v-for="(value, key) in selectpayment.data_list"
                                                    :key="key" :name="key" :value="value"> -->
                            <!-- <input type="hidden" name="Amt"
                                                    :value="selectpayment.data_list.Amt">
                                                <input type="hidden" name="MerchantID"
                                                    :value="selectpayment.data_list.MerchantID">
                                                <input type="hidden" name="MerchantOrderNo"
                                                    :value="selectpayment.data_list.MerchantOrderNo">
                                                <input type="hidden" name="TimeStamp"
                                                    :value="selectpayment.data_list.TimeStamp">
                                                <input type="hidden" name="Version"
                                                    :value="selectpayment.data_list.Version">
                                                <input type="hidden" name="LoginType"
                                                    :value="selectpayment.data_list.LoginType">
                                                <input type="hidden" name="RespondType"
                                                    :value="selectpayment.data_list.RespondType">
                                                <input type="hidden" name="ItemDesc"
                                                    :value="selectpayment.data_list.ItemDesc">
                                                <input type="hidden" name="TokenTerm"
                                                    :value="selectpayment.data_list.TokenTerm">
                                                <input type="hidden" name="CheckValue"
                                                    :value="selectpayment.data_list.CheckValue">
                                                <input type="hidden" name="ReturnURL"
                                                    :value="selectpayment.data_list.ReturnURL">
                                                <input type="hidden" name="NotifyURL"
                                                    :value="selectpayment.data_list.NotifyURL">
                                                <input type="hidden" name="CustomerURL"
                                                    :value="selectpayment.data_list.CustomerURL">
                                                <input type="hidden" name="ClientBackURL"
                                                    :value="selectpayment.data_list.ClientBackURL">
                                                <input type="hidden" name="Email"
                                                    :value="selectpayment.data_list.Email">
                                                <input type="hidden" name="OrderComment"
                                                    :value="selectpayment.data_list.OrderComment">
                                                <input type="hidden" name="CREDIT"
                                                    :value="selectpayment.data_list.CREDIT"> -->

                        </form>
                    </div>
                    <!-- <div class="ordertitle">
                        <div class="txt_scam_wrap">
                            <div class="txt_scam_title d-flex justify-content-center">
                                <i class="icon-exclamation-triangle"></i>
                                <h4 class="mb-0">防詐騙提醒 NOTICE</h4>
                            </div>
                            <div class="txt_scam_info">
                                <p><b> 芽米寶貝嬰幼兒副食品YummyBaby 貼心提醒您</b><br>近期詐騙猖獗，行騙手法也不斷更新，為保障您的資訊安全，請特別留意！ </p>
                                <p class="mb-5">我們不會以電話主動要求客戶進行以下事項：</p>
                                <ul class="txt_scam_list list-unstyled mb-5">
                                    <li><i class="icon-clear d-flex"></i><b>不會要求您操作自動櫃員機(ATM)進行轉帳或其他行為</b></li>
                                    <li><i class="icon-clear d-flex"></i><b>不會要求您提供個人付款帳戶或信用卡資料</b></li>
                                    <li><i class="icon-clear d-flex"></i><b>不會以誤設定分期多次扣款/會員權益為由要求客戶進行付款</b></li>
                                    <li><i class="icon-clear d-flex"></i><b>不會要求變更ATM分期付款設定/更改帳務資訊</b></li>
                                </ul>
                                <p>詐騙電話尤以<b>+886</b>開頭為大宗，請務必提高警覺，勿理會！ </p>
                                <p class="mb-0">歹徒會以更改訂單、退費、解除分期、會員優惠等內容為由，要求您操作ATM、提供信用卡資訊等，這些都是詐騙手法，請勿信。<br>若遇可疑來電，歡迎您聯繫客服查詢
                                </p>
                            </div>
                        </div>
                    </div> -->
                    <div class="order_details">
                        訂單明細
                    </div>
                    <hr>
                    <div class="serial_number">
                        訂單編號：<b>{{ item.order.order_num }}</b>
                    </div>
                    <section class="cart_detail_area">
                        <!-- 头部 -->
                        <header class="item_header" style="">
                            <div class="th_product">品名</div>
                            <div class="th_specification css_th">規格</div>
                            <div class="th_quantity css_th">數量</div>
                            <div class="th_price css_th">單價</div>
                            <div class="th_subtotal css_th">小計</div>
                            <!-- <div class="th_del css_th">刪除</div> -->
                        </header>
                        <!-- 商品列表 -->
                        <div class="item_list" v-for="items in item.item" v-if="items.type !== 'SYS'">
                            <div class="item_productinfo">
                                <!-- 名字 -->
                                <div class="td_product">
                                    <div class="item_thumbs">
                                        <img :src="items.display_img_small" :alt="items.form_name" width="50px"
                                            height="50px">
                                        <!-- <img src="https://hinetcdn.waca.ec/uploads/shops/25040/products/00/thumb_cache/75_00f8b6f750fb46a7bc5a4f83c1fb7900.jpg"
                                            width="50" height="50" alt="MINI寶寶饅頭-無鹽無糖(綜合)"> -->
                                    </div>
                                    <div class="item_info">
                                        <div class="purchase media clearfix">
                                            <div class="purchase_inner media-body">
                                                <a href="javascript:;" class="item_name"><span class="text_overflow">{{
            items.form_name }}</span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- 规格 -->
                                <div class="td_specification">
                                    <div v-if="items.sub.length !== 0">
                                        <div v-for="itemsub in items.sub" style="font-size: 12px; color: #000;">
                                            <span v-if="itemsub.sub_type == 'SFREE'" style="color: #dc3545;">贈品-{{
            itemsub.form_name }}*{{
            itemsub.num }}</span>
                                            <span v-else>{{ itemsub.form_name }}*{{ itemsub.num }}</span>
                                        </div>
                                    </div>
                                    <span v-else>單一規格</span>
                                </div>
                                <!-- 数量 -->
                                <div class="td_quantity">

                                    <div class="css_td">数量：{{ items.num }}</div>
                                    <div class="css_th">{{ items.num }}</div>
                                    <!-- <select class="form_select form_control">
                                        <option value="1" selected="">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                    </select> -->
                                </div>
                                <!-- 单价 -->
                                <div class="th_price css_th">
                                    <div class="item_price">${{ items.price }}</div>
                                </div>
                                <!-- 小计 -->
                                <div class="td_subtotal ">
                                    <div class="item_subtotal css_th" data-subtotal="小計："><b>${{ items.total }}</b>
                                    </div>
                                    <div class="item_subtotal_node" data-subtotal="小計：">小計：<b>${{ items.total }}</b>
                                    </div>
                                </div>
                                <!-- 删除 -->
                                <div class="td_del">
                                    <!-- <div class="item_del"><a href="javascript:void(0);"><i class="icon-new_trash"
                                                style="color: #6E7C7C;"></i></a></div> -->
                                </div>
                            </div>
                            <!-- 优惠提示 -->
                            <!-- <div class="item_promotion item_list_tr">
                                <div class="standard clearfix">
                                    <div class="item_icon"><span>已符合</span></div><a href="javascript:;"
                                        class="item_sale text_overflow" target="_blank">【芽米嚴選商品】任選1件折10元</a>
                                </div>
                            </div> -->
                        </div>
                        <!-- 現金積點 -->
                        <!-- <div class="item_list">
                            <div class="d-table">
                                <div class="item_productinfo item_gift">
                                    <div class="td_product">
                                        <div class="gift clearfix">
                                            <div class="item_icon">
                                                <span>現金積點</span>
                                            </div>
                                            <label class="discount_detail_lab d-flex align-items-center mb-0">
                                                <div class="discount_info_area d-flex align-self-start mr-5">
                                                    <i class="icon-new_info"></i>
                                                </div>
                                                <h5 class="item_sale text_overflow">
                                                    會員 滿 $ <span class="red ">100</span> 元，現金積點回饋 <span class="red ">1點</span>
                                                </h5>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="td_specification css_th"></div>
                                    <div class="td_quantity css_th"></div>
                                    <div class="td_price css_th"></div>
                                    <div class="td_subtotal redeem_points">
                                        <div class="item_subtotal red">1 點</div>
                                    </div>
                                    <div class="td_del css_th">
                                        <div class="item_del"></div>
                                    </div>
                                </div>
                            </div>
                            <h5 class="redeem_tips  " data-value="2">
                                詳細請參閱「<label class="mb-0"> 現金積點規則 </label>」。
                            </h5>
                        </div> -->
                        <!-- 优惠代码 -->
                        <div class="item_list w-100 d-none">
                            <!-- <div class="row"> -->
                            <div class="promotion_code col-lg-6 offset-lg-6 col-md-6 offset-md-6">
                                <div class="row">
                                    <div class=" form_label col-md-4 col-sm-2 col-xs-4">
                                        <label>優惠代碼</label>
                                    </div>
                                    <div class="form_data col-md-8 col-sm-10 col-xs-8">
                                        <!-- <div class="form_data"> -->
                                        <input class="form_input " placeholder="請輸入優惠代碼" type="text" value="">

                                    </div>
                                </div>
                            </div>
                            <!-- </div> -->
                        </div>
                        <!-- 计算总价格 -->
                        <div class="item_discount">

                            <!-- 小计 -->
                            <div class="item_last_subtotal item_row">
                                <div class="item_desc">
                                    <p class="mb-0">小計</p>
                                </div>
                                <b class="item_money">${{ total | formatNumberToqff }}</b>
                            </div>
                            <!-- 运费 -->
                            <div class="item_shipment item_row">
                                <div class="item_desc">
                                    <label for="freight_detail" class="freight_detail_lab js_freight_list mb-0"
                                        title="運費詳情">
                                        <span>運費</span>
                                    </label>

                                </div>
                                <b class="item_money">
                                    ${{ order_freight }}
                                </b>
                            </div>
                            <!-- <div class="item_shipment item_row">
                                <div class="item_desc">
                                    <label for="freight_detail" class="freight_detail_lab js_freight_list mb-0" title="運費詳情">
                                        <span>代收手續費 $ 30 元宅配代收
                                        </span>
                                    </label>
        
                                </div>
                                <b class="item_money">
                                    $30
                                </b>
                            </div> -->
                        </div>
                        <footer class="item_footer">
                            <div class="item_total item_row" style="background-color: #6E7C7C;">
                                <div class="item_desc">
                                    <span class="item_total_title">總金額</span>
                                    <span class="item_currency">(TWD)</span>
                                </div>
                                <div class="item_money">
                                    <b class="item_total_inner">
                                        ${{ item.total }}
                                    </b>
                                </div>
                            </div>
                        </footer>

                    </section>
                </div>
                <div class="item_area">
                    <header class="title_area clearfix">
                        <h4 class="main_title">訂單狀態</h4>
                        <hr>
                    </header>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form_group">
                                <label class="form_label" for="">購買日期</label>
                                <div class="form_data">
                                    <h5 class="form_info">{{ item.order.created_at }}</h5>
                                </div>
                            </div>
                            <div class="form_group">
                                <label class="form_label" for="">訂單編號</label>
                                <div class="form_data">
                                    <h5 class="form_info">{{ item.order.order_num }}</h5>
                                </div>
                            </div>
                            <!-- <div class="form_group">
                                <label class="form_label" for="">認證號碼</label>
                                <div class="form_data">
                                    <h5 class="form_info">DhFMtar2P3</h5>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="item_area">
                    <header class="title_area clearfix">
                        <h4 class="main_title">訂單資訊</h4>
                        <hr>
                    </header>
                    <div class="row">
                        <div class="col-md-6">

                            <div class="form_payinfo">
                                <h4 class="form_subtitle"><b>購買人資訊</b></h4>
                                <div class="form_group">
                                    <label class="form_label" for="">購買人姓名</label>
                                    <div class="form_data">
                                        <h5 class="form_info">{{ item.receiver.name }}</h5>
                                    </div>
                                </div>
                                <!-- <div class="form_group">
                                    <label class="form_label" for="">購買人電子信箱</label>
                                    <div class="form_data">
                                        <h5 class="form_info">ces**@qq.com</h5>
                                    </div>
                                </div> -->
                                <div class="form_group">
                                    <label class="form_label" for="">購買人電話</label>
                                    <div class="form_data">
                                        <h5 class="form_info">{{ item.receiver.phone }}</h5>
                                    </div>
                                </div>
                                <div class="form_group">
                                    <label class="form_label" for="">客戶備註</label>
                                    <div class="form_data">
                                        <h5 class="form_info"><span class="form_info_note">{{ item.receiver.note
                                                }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="form_payinfo">
                                <h4 class="form_subtitle"><b>付款資訊</b></h4>
                                <div class="form_group">
                                    <label class="form_label" for="">付款方式</label>
                                    <div class="form_data">

                                        <h5 class="form_info">{{ selectpayment.pay_name }} </h5>
                                        <h5 class="form_info">{{ item.payment.status_name }} </h5>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form_payinfo">
                                <h4 class="form_subtitle"><b>收件人資訊</b></h4>
                                <div class="form_group">
                                    <label class="form_label" for="">收件人姓名</label>
                                    <div class="form_data">
                                        <h5 class="form_info">{{ item.receiver.name }}</h5>
                                    </div>
                                </div>
                                <div class="form_group">
                                    <label class="form_label" for="">收件人電話</label>
                                    <div class="form_data">
                                        <h5 class="form_info">{{ item.receiver.phone }}</h5>
                                    </div>
                                </div>
                                <div class="form_group">
                                    <label class="form_label" for="">收件地址</label>
                                    <div class="form_data">
                                        <h5 class="form_info">
                                            {{ item.receiver.address }}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="form_payinfo">
                                <h4 class="form_subtitle"><b>配送資訊</b></h4>
                                <!-- <div class="form_group">
                                    <label class="form_label" for="">運送方式</label>
                                    <div class="form_data">
                                        <h5 class="form_info">貨到付款</h5>
                                    </div>
                                </div> -->
                                <div class="form_group">
                                    <label class="form_label" for="">出貨狀態</label>
                                    <div class="form_data">
                                        <h5 class="form_info"
                                            v-if="order[0].progress.message != '' && order[0].progress.message != null">
                                            {{ order[0].progress.message }}</h5>
                                        <formStep :stepData="stepData" :stepActive="stepActive"></formStep>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="query_btn_area d-flex">
                        <button class="btn el_btn md solid   m-0  " type="button"
                            style="background-color: #F17C67;border-color:#F17C67;color: #ffffff;">
                            <span class="el_text_inner"><router-link to="/check_order">查詢訂單</router-link></span>
                        </button>
                        <button class="btn el_btn md solid   m-0  " type="button"
                            style="background-color: #6E7C7C;border-color:#6E7C7C;color: #ffffff;">
                            <span class="el_text_inner"><router-link to="/">回首頁</router-link></span>
                        </button>
                    </div>
                    <div class="form_group mb-0">
                        <div class="d-flex justify-content-end">
                            <div class="help_block help_tips" style="color: #27ae61; margin-top: 5px; font-size: 14px;">
                                <i class="icon-triangle-right"></i><span>請查閱信箱中的「訂購通知信」。</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="order_false" v-else-if="judgment == 'false'">
            暫無此訂單
        </div>
        <!-- <div v-else-if=""></div> -->
    </div>
</template>

<script>




import formStep from '@/components/step.vue';
import { mapState } from 'vuex'
import numeral from "numeral";

export default {
    components: { formStep },
    data() {
        return {
            total: 0,
            order_freight: 0,
            judgment: '',
            now_url: '',
            status: {
                PENDING: false,
                TALLY: false,
                SHIPPING: false,
                DELIVERED: false,
            },
            status_name: {
                PENDING: '尚未處理',
                TALLY: '倉庫理貨',
                SHIPPING: '物流配送',
                DELIVERED: '完成',
            },
            stepActive: 1, //当前进度
            stepData: [
                {
                    status: "尚未處理"
                },
                {
                    status: "倉庫理貨"
                },
                {
                    status: "物流配送"
                },
                {
                    status: "完成"
                }
            ],

        };
    },
    filters: {
        formatNumberToqff(val) {
            return numeral(val).format('0,0');
        }
    },
    computed: {
        // ...mapState('header', ['cate']),
        ...mapState('order', ['payment_method', 'selectpayment', 'order']),
        ...mapState('cart', ['number', 'cart_list_item', 'freight', 'cart_list'])
    },
    watch: {},
    methods: {
        call_back() {
            this.$store.dispatch('order/payment_one', this.$route.params.order_num).then((e) => {
                if (e.st === "checking") {
                    // 如果状态为 "checking"，等待 10 秒后再次请求
                    setTimeout(() => {
                        this.call_back();
                    }, 10000); // 10 秒
                } else if (e.st === "success") {
                    this.$store.dispatch('order/payment_two', { data: this.$route.params.order_num }).then(() => {
                        let item = this.$store.getters['order/order']
                        item[0].item.forEach((e) => {
                            if (e.type !== 'SYS') {

                                this.total += e.total.replace(/,/g, "") * 1
                            }
                        })
                        this.order_freight = item[0].total.replace(/,/g, "") * 1 - this.total;
                        if (this.order[0]) {
                            // 统计对象中true的数量
                            const trueCount = Object.values(this.order[0].progress.status).reduce((count, value) => count + (value === true), 0);
                            // 计算step的值，并确保它在1到4之间
                            this.stepActive = Math.min(Math.max(1, trueCount), 4);
                        }
                    }).catch(error => {
                        // 处理错误
                        console.error('An error occurred:', error);
                    });;
                } else {
                    // 状态不是 "checking"，结束循环
                    // 在这里处理不是 "checking" 的状态
                    console.log('状态已改变，停止循环');
                }
                // console.log(1);
            }).catch(error => {
                // 处理错误
                console.error('An error occurred:', error);
            });
        },
        set_st() {
            let x = {
                "is_background": "N",
                "mode": "ATMTransfer",
                "st": "success",
                "bk_code": "013",
                "bk_acc": "2803120446021787",
                "st_code": "",
                "furl": "https://payment.ecpay.com.tw/Cashier/AioCheckOut/V5",
                "fmethod": "POST",
                "data_list": 1,
                "pay_info": "",
                "pay_name": "綠界-ATM",
                "bank_info_manual": null
            }
            this.$store.commit('order/set_selectpayment', x)
        }
    },
    created() {
    },
    mounted() {
        this.now_url = window.location.href;
        this.$store.dispatch('order/payment_one', this.$route.params.order_num).then((e) => {
            if (e == false) {
                this.judgment = 'false'
            } else {
                this.judgment = 'true'
                setTimeout(() => {
                    this.call_back();
                }, 10000); // 10 秒
            }
            // console.log(1);
        }).catch(error => {
            // 处理错误
            console.error('An error occurred:', error);
        });
        this.$store.dispatch('order/payment_two', { data: this.$route.params.order_num }).then(() => {
            let item = this.$store.getters['order/order']
            item[0].item.forEach((e) => {
                if (e.type !== 'SYS') {

                    this.total += e.total.replace(/,/g, "") * 1
                }
            })
            this.order_freight = item[0].total.replace(/,/g, "") * 1 - this.total;
            if (this.order[0]) {
                // for (const key in this.status) {
                //     if (this.order[0].progress.status.hasOwnProperty(key)) {
                //         this.status[key] = this.order[0].progress.status[key];
                //     }
                // }
                // 统计对象中true的数量
                const trueCount = Object.values(this.order[0].progress.status).reduce((count, value) => count + (value === true), 0);

                // 计算step的值，并确保它在1到4之间
                this.stepActive = Math.min(Math.max(1, trueCount), 4);

            }
        }).catch(error => {
            // 处理错误
            console.error('An error occurred:', error);
        });;
        // console.log(2);

    },
}
</script>

<style lang='scss' scoped src="./order.scss"></style>

<style lang="scss" scoped>
#atm {
    padding: 10px 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    svg {
        width: 18px;
        position: relative;
        top: .18em;
    }

    .status {
        width: 16em;

        .to_pay {
            background-color: #fdf8e4;
            color: #886B3E;
            padding: 1em 0;


        }

        .to_get {
            background-color: #f2dede;
            color: #db524f;
            padding: 1em 0;
        }
    }

    .button {
        width: 16em;

        .to_pay {
            text-align: left;
            background-color: #DDEEDA;
            color: #417F57;
            padding: 0.5em;
        }

        .to_get {
            background-color: #db524f;
            color: #fff;
            border: none;
        }

        button {
            width: 100%;
            cursor: pointer;
            padding: 1em 0;
            transition: all 0.2s linear;

            &:hover {
                opacity: 0.9;
            }
        }
    }

    .tips {
        width: 15em;
        font-size: .8em;
        color: red;
        text-align: left;

        svg {
            width: 14px;
        }
    }
}
</style>